// src/setup/patchFetch.ts
export function patchGlobalFetch() {
  // Guardamos la implementación original tipada
  const originalFetch: typeof fetch = window.fetch.bind(window);

  // Creamos nuestra versión parcheada con el MISMO tipo que fetch
  const patchedFetch: typeof fetch = async (input, init) => {
    const token = localStorage.getItem("vg_token");

    // Nos aseguramos de no romper el init
    const newInit: RequestInit = {
      ...(init || {}),
      headers: {
        ...(init && init.headers ? init.headers : {}),
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      }
    };

    const response = await originalFetch(input, newInit);

    if (response.status === 401) {
      console.warn("No autorizado (401). Redirigiendo al login...");

      // Limpieza de sesión
      localStorage.removeItem("vg_token");
      localStorage.removeItem("vg_refresh_token");

      // Redirección al login
      window.location.href = "/login";
    }

    return response;
  };

  // Asignamos nuestra versión parcheada
  window.fetch = patchedFetch;
}
